import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid container-fluid-padding" }
const _hoisted_2 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#purchaseDeclarationModal",
  href: "#",
  target: "_blank"
}
const _hoisted_3 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#privacyModal",
  href: "#",
  target: "_blank"
}
const _hoisted_4 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#cookiesModal",
  href: "#",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_top = _resolveComponent("header-top")!
  const _component_header_menu = _resolveComponent("header-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_footer_container = _resolveComponent("footer-container")!
  const _component_SessionEndComponent = _resolveComponent("SessionEndComponent")!

  return (!_ctx.StandAlonePages.includes(_ctx.currRouteName))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_header_top),
          _createVNode(_component_header_menu, { "menu-data": _ctx.menu }, null, 8, ["menu-data"]),
          _createVNode(_component_router_view),
          _createVNode(_component_footer_container, null, {
            "purchase-declaration-link": _withCtx(() => [
              _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$t('purchase_declaration')), 1)
            ]),
            "privacy-link": _withCtx(() => [
              _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('privacy_policy')), 1)
            ]),
            "cookies-link": _withCtx(() => [
              _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('cookies_consent')), 1)
            ]),
            _: 1
          })
        ]),
        (_ctx.store.state.customer.sessionEnd)
          ? (_openBlock(), _createBlock(_component_SessionEndComponent, {
              key: 0,
              class: "container container-choose-route d-flex flex-column align-items-center"
            }))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}